// extracted by mini-css-extract-plugin
export default {"text":"text___rAKZf","logos":"logos___ZLSvZ","phone":"phone___JFeNU"};